import { useSearchParams } from 'react-router-dom';

const SearchNotFound = () => {
    const [searchParams] = useSearchParams();
    const keyword = searchParams.get('keyword');
    return (
        <div id="not-found-search">
            <div className="title">
                <h1>
                    ‘{keyword}’ <span>에 대한 검색결과가 없습니다.</span>
                </h1>
                <p>검색어를 다시 확인해 주세요.</p>
            </div>
            <div className="info">
                {/* <i className="icon icon-info" /> */}
                <span className='icon-info'>i</span>
                <p>
                    이렇게
                    <br />
                    검색해보세요!
                </p>
                <ul>
                    <li className="dot">검색어를 올바르게 입력했는지 확인해보세요.</li>
                    <li className="dot">검색어의 단어 수를 줄이거나 보다 일반적인 검색으로 다시 검색해보세요.</li>
                    <li className="dot">찾으시는 업무명 등으로 검색해보세요.</li>
                </ul>
            </div>
        </div>
    );
};
export default SearchNotFound;
